export default "__VITE_ASSET___ghBZXuI__"